import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var baseStyle = defineStyle(function (props) {
    return {
        borderRadius: '4px'
    };
});
var skeletonTheme = defineStyleConfig({
    baseStyle: baseStyle
});

export { skeletonTheme };
//# sourceMappingURL=skeleton.js.map
